import { AiSchemas } from './ai.js';

/**
 * Attempt to parse AI content using the schema for a given prompt key.
 * - For narrative prompts, returns { narrative: string }
 * - For JSON prompts, safely extracts JSON from text and validates with Zod
 */
export function parseAIResponse(promptKey, content) {
  const schema = AiSchemas[promptKey];
  if (!schema) {
    return { ok: false, schema: null, data: null, errors: ['no-schema'] };
  }

  // Portfolio narrative: plain string envelope
  if (promptKey === 'portfolioAnalysis') {
    const value = (content || '').toString().trim();
    if (!value) return { ok: false, schema: 'PortfolioNarrative', data: null, errors: ['empty'] };
    const parsed = schema.safeParse({ narrative: value });
    return parsed.success
      ? { ok: true, schema: 'PortfolioNarrative', data: parsed.data }
      : { ok: false, schema: 'PortfolioNarrative', data: null, errors: parsed.error.issues.map(i => i.message) };
  }

  // JSON style: try to extract JSON object from content
  let json = null;
  try {
    // Prefer pure JSON
    json = JSON.parse(content);
  } catch (_) {
    // Fallback: extract first {...} block
    const match = content?.match(/\{[\s\S]*\}/);
    if (match) {
      try { json = JSON.parse(match[0]); } catch (_) {}
    }
  }

  if (!json) {
    return { ok: false, schema: schema?.name || 'unknown', data: null, errors: ['no-json'] };
  }

  const res = schema.safeParse(json);
  return res.success
    ? { ok: true, schema: schema?.name || 'unknown', data: res.data }
    : { ok: false, schema: schema?.name || 'unknown', data: null, errors: res.error.issues.map(i => i.message) };
}

export default { parseAIResponse };

